var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"flex items-center p-3 rounded transition-all duration-200 ease-out font-medium",class:{
        'text-white bg-gray-800': _vm.isActive,
        'text-gray-500': !_vm.isActive,
        'cursor-pointer hover:text-white hover:bg-gray-800': _vm.isClickable,
        'cursor-default': !_vm.isClickable,
    },attrs:{"href":_vm.linkUrl || '#'},on:{"click":function($event){return _vm.onSelect()}}},[_c('div',{staticClass:"w-8"},[(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e()]),_c('span',{staticClass:"ds-text-xs whitespace-no-wrap"},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }